const PaymentMark = ({ src }) => <img height={32} src={src} />;

export { PaymentMark };
